import {
  IMyinfoUpdateCCP,
  IMyinfoValidation,
  PRODUCT_CODE_API,
  getMyInFoRecord,
  postContactCCP,
  postMyInfoUpdateCCP,
  postMyInfoValidation,
} from "@api/index";
import { InputGroup } from "@pages/CCP/components/InputGroup";
import { styled } from "@linaria/react";
import { MyInfo } from "@models/CCP/myinfo.model";
import HealthMainContainer from "@components/_Revamp/HealthMainContainer";
import ModalNameSelector from "@components/_Revamp/ListMyinfoChild/Modal/ModalNameSelector";
import { useAvivaDispatch, useAvivaSelector } from "@redux/hook";
import {
  updateErrorMyInfoRecord,
  updateIsMyInfoSubmitted,
  updateMyChildRecord,
  updateMyInfoRecord,
  updateMyInfoTransactionId,
  updateRentalPostalCustomer,
  updatePartialDataStep4,
} from "@redux/slices/CCP/step4Slice";
import { setLoadingState } from "@redux/slices/loadingSlice";
import { ROUTE_PATH } from "@static/route-paths";
import { SCREEN_SIZE } from "@static/screen-size";
import {
  Helpers,
  LoadingScreen,
  NameSelectorItemProps,
  Validations,
  formatDate,
  getSalutationList,
  nameChunks,
  validate,
} from "@utils/helpers";
import useForm from "@utils/useForm";
import { isEmpty, isNil } from "lodash";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useHistory } from "react-router-dom";
import { themeDefault } from "src/theme-revamp";
import Link from "@components/_Revamp/Link";
import { css } from "@linaria/core";
import { Checkbox } from "@components/_Shared/Checkbox";
import Button from "@components/_Revamp/Button";
import ErrorModal from "@pages/CCP/components/Modals/ErrorModal";
import Typography from "@components/_Revamp/Typography";
import { store } from "@redux/store";
import ChildInfo from "@pages/CCP/components/ChildInfo";
import dayjs from "dayjs";
import warningIcon from "@assets/icon/info-yellow.svg";
import { trackOnCTA, trackOnLoad } from "@pages/CCP/Helpers/analyticsHelper";
import { AA } from "@utils/adobeAnalyticsSS";
import { CCPDataLayer } from "@pages/CCP/DataLayer/Datalayer.model";
import { updateReferenceNumber } from "@redux/slices/CCP/step6Slice";
import { CCP_STEP_LIST } from "@static/content";
import { ContainerWithStepper } from "@pages/CCP/components/ContainerWithStepper";
import DateOfBirthModal from "@pages/CCP/components/Modals/DateOfBirthModal";
const OBJ_KEYS = [
  "purchThroMyself",
  "existingCCPPlan",
  "doesNotQualifProd",
  "policyAppInProcess",
];

function Myinfo() {
  const urlParams: URLSearchParams = Helpers.getURLSearchParams();
  const dispatch = useAvivaDispatch();
  const history = useHistory();
  const [swapName, setSwapName] = useState<string>("");
  const errorState = useAvivaSelector((state) => state.cancerCoverStep4.error);
  const campaignCode = useAvivaSelector(
    (state) => state.loading.campaignDetail?.campaignCode || ""
  );
  const [apiError, setApiError] = useState(
    () => errorState?.error?.errorMessage
  );
  const [apiErrorTitle, setApiErrorTitle] = useState(
    () => (errorState && getErrorTitle(errorState?.errorCode)) || ""
  );
  const [firstNameListingChucks, setFirstNameListingChucks] = useState<
    NameSelectorItemProps[]
  >([]);
  const [lastNameListingChucks, setLastNameListingChucks] = useState<
    NameSelectorItemProps[]
  >([]);
  const [verifyInfo, setVerifyInfo] = useState<string>();
  const [dobModal, setDobModal] = useState<boolean>(false);
  const [myinfoData, setMyinfoData] = useState<any>();

  // State from Redux
  const personalInfo = useAvivaSelector(
    (state) => state.cancerCoverStep4.myInfo
  );

  const rentalStatusFromStore = useAvivaSelector(
    (state) => state.cancerCoverStep4.rentalPostalCustomer
  );

  const selectedChild = useAvivaSelector(
    (state) => state.cancerCoverStep4.selectedChildInfo
  );

  const isSingpassInitiated = useAvivaSelector(
    (state) => state.cancerCoverStep4.singpassInitiatedOrManual
  );
  const transactionId = useAvivaSelector(
    (state) => state.cancerCoverStep1.transactionId
  );
  const underWriting1 = useAvivaSelector(
    (state) => state.cancerCoverStep3.underWriting1
  );
  const underWriting2 = useAvivaSelector(
    (state) => state.cancerCoverStep3.underWriting2
  );
  const underWriting3 = useAvivaSelector(
    (state) => state.cancerCoverStep3.underWriting3
  );
  const myinfotransactionId = useAvivaSelector(
    (state) => state.cancerCoverStep4.myinfoTransactionId
  );

  const far = useAvivaSelector((state) => state.cancerCoverStep6.FARData.code);

  const basicInfo = useAvivaSelector(
    (state) => state.cancerCoverStep1.basicInfo
  );

  const { values, errors, patchValue, handleChange, formValid } = useForm(
    new MyInfo(personalInfo),
    () => {},
    validate
  );
  const salutationList = useMemo(
    () => getSalutationList(values["gender"] || ""),
    [values["gender"]]
  );
  const onInputChange = useCallback((e: any) => {
    handleChange(e);
    dispatch(updateMyInfoRecord({ [e.target.name]: e.target.value }));
  }, []);

  function getErrorTitle(errorCode: string) {
    let message = "";
    switch (errorCode) {
      case "1005":
        message = "You already have an existing\n Cancer Cover plan with us";
        break;

      default:
        message = "We've encountered an issue";
        break;
    }
    return message;
  }

  const handleConsent = useCallback(async (transaction_id: string) => {
    const status = urlParams.get("status");
    const isManualData = urlParams.get("manual_data");
    // To check if the manual singpass form is being used to load the personal info and to stop making api calls to fetch the data.
    if (isManualData) {
      //@ts-ignore
      if (personalInfo.error) {
        //@ts-ignore
        setApiError(personalInfo.error);
      }
      nameChunksProcesses({ ...values });
      return;
    }

    if (status === "consent_accepted" && transaction_id) {
      try {
        dispatch(setLoadingState(true));
        let { data }: any = await getMyInFoRecord(
          transaction_id,
          PRODUCT_CODE_API.CANCER_COVER,
          basicInfo?.forwhom
        );

        if (data?.myselfData) {
          const digiData = AA.getInstance()?.digitalData as CCPDataLayer;
          trackOnLoad({
            userUpdated: {
              person: { ...digiData.user.person },
            },
            formUpdated: {
              field: {
                Gender: data?.myselfData?.gender || "",
              },
            },
          });
        }
        dispatch(updateMyInfoTransactionId(transaction_id));
        //   let data = {
        //     "myselfInputDto": {
        //         "fullName": "BERNARD LI GUO HAO",
        //         "salutation": null,
        //         "firstName": null,
        //         "lastName": null,
        //         "dateOfBirth": "1991-12-04",
        //         "nric": "S0290695C",
        //         "nationality": "MALAYSIAN",
        //         "nationalityCode": "MY",
        //         "residentialStatus": "PR",
        //         "gender": "FEMALE",
        //         "mobileNum": "87163551",
        //         "emailId": "dbstesting03@gmail.com",
        //         "address": null,
        //         "age": 33,
        //         "customerId": 118513
        //     },
        //     "error": {errorMessage:null, errorCode:""},
        //     "transactionId": "6298ecc2-f310-4340-a3e5-30c1d21ac599",
        //     "rentalPostalCustomer": ""
        // }
        if (data) {
          if (data?.error && data?.error?.errorMessage) {
            setApiErrorTitle(getErrorTitle(data?.error?.errorCode));
            setApiError(data?.error?.errorMessage);
            dispatch(
              updateErrorMyInfoRecord({
                ...data?.error,
              })
            );
            return;
          }
          // if(basicInfo?.forwhom === "myself" && dobMismatchfn(data.dateOfBirth, basicInfo?.dob, false)){
          //   return;
          // }else if(basicInfo?.forwhom === "child"){
          //   const filteredChildList = data.availToPurch?.childDataList?.filter((child: any)=>{
          //     return !dobMismatchfn(child.dateOfBirth, basicInfo?.dob, true)
          //   }) || []

          //   if(data.availToPurch?.childDataList.length > 0 && filteredChildList&&  filteredChildList?.length === 0 ) {
          //     return history.replace(ROUTE_PATH.CANCER_COVER_BASIC_INFO)
          //   }
          // }

          if (
            basicInfo?.forwhom === "myself" &&
            !data?.error?.errorMessage &&
            dobMismatchfn(
              data?.myselfData?.dateOfBirth || "",
              basicInfo?.dob,
              false
            )
          ) {
            setMyinfoData(data);
            setDobModal(true);
            return;
          } else if (basicInfo?.forwhom === "child") {
            let flag = true;
            let atleastOneCategoryHasMatchDOB = false;
            for (const key of OBJ_KEYS) {
              if (data[key] && Array.isArray(data[key]?.childDataList)) {
                const found = data[key].childDataList.find(
                  (child: { dateOfBirth: string }) => {
                    return !dobMismatchfn(
                      basicInfo?.dob || "",
                      child?.dateOfBirth,
                      true
                    );
                  }
                );

                if (found) {
                  atleastOneCategoryHasMatchDOB = true;
                  break;
                }
              }
            }
            const filteredChildList =
              data?.availToPurch?.childDataList?.reduce(
                (acc: any, child: any) => {
                  const isDisabled = dobMismatchfn(
                    child.dateOfBirth,
                    basicInfo?.dob,
                    true
                  );
                  const childNew = { ...child, isDisabled };
                  acc.push(childNew);
                  if (!isDisabled && flag) {
                    flag = false;
                  }
                  return acc;
                },
                []
              ) || [];

            data = {
              ...data,
              availToPurch: { childDataList: filteredChildList },
            };

            if (
              flag &&
              !atleastOneCategoryHasMatchDOB &&
              !data?.error?.errorMessage
            ) {
              setMyinfoData(data);
              setDobModal(true);
              return;
            } else if (!data?.error?.errorMessage) {
              dispatch(updatePartialDataStep4({ dobMisMatch: false }));
            }
          }
          const myselfData: any = data.myselfData;
          personalInfo?.salutation &&
            isEmpty(myselfData?.salutation) &&
            delete myselfData.salutation;
          personalInfo?.emailId &&
            isEmpty(myselfData?.emailId) &&
            delete myselfData.emailId;
          personalInfo?.mobileNum &&
            isEmpty(myselfData?.mobileNum) &&
            delete myselfData.mobileNum;
          patchValue(myselfData);
          // if(myselfData?.dob) {}
          nameChunksProcesses({ ...myselfData });
          dispatch(updateMyInfoRecord(myselfData));
          dispatch(updateRentalPostalCustomer(data?.rentalPostalCustomer));

          if (basicInfo?.forwhom === "child") {
            dispatch(
              updateMyChildRecord({
                availToPurch: data.availToPurch?.childDataList || null,
                doesNotQualifProd:
                  data.doesNotQualifProd?.childDataList || null,
                existingCCPPlan: data.existingCCPPlan?.childDataList || null,
                purchThroMyself: data.purchThroMyself?.childDataList,
                policyAppInProcess:
                  data.policyAppInProcess?.childDataList || null,
              })
            );
          }
        }
      } catch (err) {
        history.push(ROUTE_PATH.CANCER_COVER_CONTACT_US);
      } finally {
        dispatch(setLoadingState(false));
      }
      // trackOnLoad("sss_myinfo_form");
    } else {
      history.replace(
        `${ROUTE_PATH.CANCER_COVER_SINGPASS}?transaction_id=${transaction_id}&status=${status}`
      );
    }
  }, []);

  //TODO replace this with new dispatch for the secure saver
  const updateInfoFn = (info: any) => {
    dispatch(
      updateMyInfoRecord({
        ...personalInfo,
        ...info,
      })
    );
  };

  const myInfoValidation = async () => {
    try {
      LoadingScreen();
      dispatch(
        updateMyInfoRecord({
          ...personalInfo,
          firstName: values["firstName"],
          lastName: values["lastName"],
        })
      );
      const payload2 = {
        transactionId: transactionId || "",
        fullName: personalInfo.fullName || "",
        salutation: personalInfo.salutation || "",
        mobileNumber: personalInfo.mobileNum || "",
        email: personalInfo.emailId || "",
        dateOfBirth: personalInfo.dateOfBirth || "",
        product: "CANCERCOVERPLUS",
        rentalPostalCustomer: rentalStatusFromStore || "",
        agentCode: far || null,
        dropPoint: "QNB_CCP_SINGPASS_DROPOFF",
        cc: null,
      };
      const payload: IMyinfoUpdateCCP = {
        transactionId: transactionId,
        customerId: Number(personalInfo.customerId),
        email: personalInfo.emailId,
        firstName: values["firstName"],
        lastName: values["lastName"],
        mobileNumber: personalInfo.mobileNum,
        customerConsent: personalInfo.stayInTouch,
        salutation: personalInfo.salutation,
        insuredType: "myself",
        underwritingQuestions: {
          health: [
            {
              questionId: "UW-1A",
              answer: underWriting1?.isMedication === "YES" ? "Y" : "N",
            },
            {
              questionId: "UW-1B1",
              answer: underWriting1?.isBenignGrowths === "YES" ? "Y" : "N",
            },
            {
              questionId: "UW-1B2",
              answer:
                underWriting1?.isBenignGrowths === "NO"
                  ? "N"
                  : underWriting1?.isTreatment === "YES"
                  ? "Y"
                  : "N",
            },
            {
              questionId: "UW-1B3",
              answer:
                underWriting1?.isBenignGrowths === "NO"
                  ? "N"
                  : underWriting1?.isRecurrence === "YES"
                  ? "Y"
                  : "N",
            },
            {
              questionId: "UW-1B4",
              answer:
                underWriting1?.isBenignGrowths === "NO"
                  ? "N"
                  : underWriting1?.isBreastGrowths === "YES"
                  ? "Y"
                  : "N",
            },
            {
              questionId: "UW-1B5",
              answer:
                underWriting1?.isBenignGrowths === "NO"
                  ? "N"
                  : underWriting1?.isColonPolyps === "YES"
                  ? "Y"
                  : "N",
            },
            {
              questionId: "UW-1B6",
              answer:
                underWriting1?.isBenignGrowths === "NO"
                  ? "N"
                  : underWriting1?.isOtherBenignGrowths === "YES"
                  ? "Y"
                  : "N",
            },
            {
              questionId: "UW-2",
              answer: underWriting2?.doneScreening === "YES" ? "Y" : "N",
              ...(underWriting2?.doneScreening === "YES" && {
                remarks:
                  underWriting2?.result === "ABNORMAL"
                    ? "b"
                    : underWriting2?.result === "NORMAL"
                    ? "a"
                    : "c",
              }),
            },
            {
              questionId: "UW-2A",
              answer:
                underWriting2.doneScreening === "NO"
                  ? "NA"
                  : underWriting2?.result === "ABNORMAL"
                  ? underWriting2?.abnormalResult === "YES"
                    ? "Y"
                    : "N"
                  : "NA",
            },
            {
              questionId: "UW-3",
              answer:
                underWriting3?.hasSymptomsinSixMonths === "YES" ? "Y" : "N",
            },
          ],
        },
      };

      if (basicInfo?.forwhom === "child") {
        payload.insuredType = "child";
        payload.childData = {
          birthCertNo: selectedChild?.nric || "",
          firstName: selectedChild?.firstName || "",
          lastName: selectedChild?.lastName || "",
          salutation:
            selectedChild?.gender.toLowerCase() === "male" ? "Mr" : "Ms",
        };
      }
      const [{ data }, { data: data2 }]: [any, any] = await Promise.all([
        postMyInfoUpdateCCP(payload),
        postContactCCP(payload2 as any),
      ]);

      const { emailStatus, mobileStatus, enableConfirm, referenceNumber } =
        data;

      if (emailStatus && mobileStatus && enableConfirm) {
        dispatch(updateIsMyInfoSubmitted(true));
        dispatch(updateReferenceNumber(referenceNumber));
        history.push(ROUTE_PATH.CANCER_COVER_MAILING_ADDRESS);
      }
    } catch (e) {
      //TODO handle the error cases post business confirmation
    } finally {
      LoadingScreen(false);
    }
  };

  const firstNameOnChange = (value: any) => {
    const fullName = values["fullName"]?.trim();
    let firstNameItems = value;

    let tempObjFirstName: NameSelectorItemProps[] = [];
    let tempObjLastName: NameSelectorItemProps[] = [];
    const arr = fullName?.split(" ");

    arr.forEach((e: any, i: number) => {
      const nameIndex = firstNameItems.findIndex(
        (items: any) => i === items.id
      );
      const isFirstName = nameIndex !== -1;
      let tempFNChucks = {
        id: i,
        title: e,
        selected: isFirstName,
        order: nameIndex,
      };
      tempObjFirstName.push(tempFNChucks);
      tempObjLastName.push({ ...tempFNChucks, selected: !isFirstName });
    });

    let fname = "";
    let lname = "";
    firstNameItems.forEach((e: any, i: number) => {
      fname += e.title + " ";
    });
    tempObjLastName.forEach((e) => {
      e.selected && (lname += e.title + " ");
    });

    setFirstNameListingChucks([...tempObjFirstName]);
    setLastNameListingChucks([...tempObjLastName]);

    patchValue({
      firstName: fname.trim(),
      lastName: lname.trim(),
    });
    updateInfoFn &&
      updateInfoFn({
        firstName: fname.trim(),
        lastName: lname.trim(),
      });
  };

  const lastNameOnchange = (value: any) => {
    const fullName = values["fullName"]?.trim();
    let lastNameItems = value;

    let tempObjFirstName: NameSelectorItemProps[] = [];
    let tempObjLastName: NameSelectorItemProps[] = [];
    const arr = fullName?.split(" ");

    arr.forEach((e: any, i: number) => {
      const nameIndex = lastNameItems.findIndex((items: any) => i === items.id);
      const isFirstName = nameIndex !== -1;
      let tempFNChucks = {
        id: i,
        title: e,
        selected: isFirstName,
        order: nameIndex,
      };
      tempObjLastName.push(tempFNChucks);
      tempObjFirstName.push({ ...tempFNChucks, selected: !isFirstName });
    });

    let fname = "";
    let lname = "";
    lastNameItems.forEach((e: any) => {
      lname += e.title + " ";
    });
    tempObjFirstName.forEach((e) => {
      e.selected && (fname += e.title + " ");
    });

    setFirstNameListingChucks([...tempObjFirstName]);
    setLastNameListingChucks([...tempObjLastName]);

    patchValue({
      firstName: fname.trim(),
      lastName: lname.trim(),
    });
    updateInfoFn &&
      updateInfoFn({
        firstName: fname.trim(),
        lastName: lname.trim(),
      });
  };

  const nameChunksProcesses = (myselfData: any) => {
    const tempName =
      values["fullName"]?.trim() || myselfData["fullName"]?.trim();
    let tempFirstName =
      values["firstName"] ||
      myselfData["firstName"] ||
      (tempName && tempName.split(" ").slice(0, -1).join(" "));
    let tempLastName =
      values["lastName"] ||
      myselfData["lastName"] ||
      (tempName && tempName.split(" ").pop());

    nameChunks(
      tempName,
      "firstName",
      tempFirstName,
      setFirstNameListingChucks,
      setLastNameListingChucks
    );
    nameChunks(
      tempName,
      "lastName",
      tempLastName,
      setFirstNameListingChucks,
      setLastNameListingChucks
    );

    patchValue({
      ...myselfData,
      firstName: tempFirstName,
      lastName: tempLastName,
    });
    updateInfoFn &&
      updateInfoFn({
        firstName: tempFirstName,
        lastName: tempLastName,
      });
  };

  const verifyAge = useCallback(() => {
    const minAge = 17,
      maxAge = 75;
    const dateOfBirth = personalInfo?.dateOfBirth;
    if (!dateOfBirth) {
      setVerifyInfo("dateOfBirthInvalid");
      return false;
    }
    const [year, month, day] = dateOfBirth.split("-");
    const stringDate = `${month}/${day}/${year}`;
    if (isNil(year) && (isNil(day) || isNil(month))) {
      setVerifyInfo("dateOfBirthInvalid");
      return false;
    } else {
      const refDay = new Date(stringDate);
      const aged = Helpers.getAge(refDay);
      if (aged < minAge) {
        setVerifyInfo("dateOfBirthLess");
        return false;
      }
      if (aged > maxAge) {
        setVerifyInfo("dateOfBirthMore");
        return false;
      }
    }
    return true;
  }, [personalInfo?.dateOfBirth]);

  const verifyResidental = useCallback(() => {
    const residentalNation = personalInfo?.nationalityCode;
    const residentalPR = personalInfo?.residentialStatus;
    if (residentalNation !== "SG" && residentalPR !== "PR") {
      setVerifyInfo("residentalError");
      return false;
    }
    return true;
  }, [personalInfo?.nationalityCode, personalInfo?.residentialStatus]);

  const verifyIncomplete = useCallback(() => {
    if (
      !personalInfo?.age ||
      // !personalInfo?.emailId ||
      !personalInfo?.fullName ||
      !personalInfo?.gender ||
      // !personalInfo?.mobileNum ||
      !personalInfo?.nationalityCode ||
      !personalInfo?.nationality ||
      !personalInfo?.nric ||
      !personalInfo?.residentialStatus ||
      !personalInfo?.address ||
      !personalInfo?.address?.block ||
      !personalInfo?.address?.street ||
      !personalInfo?.address?.postal ||
      !personalInfo?.address?.country
    ) {
      setVerifyInfo("incompleteInfo");
      return false;
    }
    return true;
  }, [personalInfo]);

  const getErrorInfor = useCallback(() => {
    if (apiError) {
      return {
        title: apiErrorTitle,
        description: apiError,
      };
    } else {
      switch (verifyInfo) {
        case "dateOfBirthInvalid":
          return {
            description:
              "It looks like you are not eligible for this product due to invalid age.\nYou may wish to find out more about Singlife Shield which maybe more suitable for you.",
          };
        case "dateOfBirthLess":
          return {
            description:
              "It looks like you are not eligible for this product due to invalid age. You must be older than 17 years old at your next birthday to be eligible.\nYou may wish to find out more about Singlife Shield which maybe more suitable for you.",
          };
        case "dateOfBirthMore":
          return {
            description:
              "It looks like you are not eligible for this product due to invalid age. You must be younger than 75 years old at your next birthday to be eligible.\nYou may wish to find out more about Singlife Shield which maybe more suitable for you.",
          };
        case "residentalError":
          return {
            description:
              "This product is only for Singapore Citizens and Permanent Residents.\nYou may wish to contact us for assistance.",
          };
        case "incompleteInfo":
          return {
            description:
              "Sorry, we are unable to retrieve your personal details. It looks like you might need assistance from a Financial Adviser Representative",
          };
        default:
          return {
            description:
              "Sorry, we are unable to retrieve your personal details. It looks like you might need assistance from a Financial Adviser Representative",
          };
      }
    }
  }, [apiError, apiErrorTitle, verifyInfo]);

  const dobMismatchfn = (
    dateOfBirth: string,
    basicInfoDate: string | undefined,
    isChild: boolean
  ) => {
    if (!dayjs(dateOfBirth).isSame(basicInfoDate)) {
      if (!isChild) {
        dispatch(
          updatePartialDataStep4({
            singpassInitiatedOrManual: null,
            selectedChildInfo: null,
            error: null,
            availToPurch: null,
            purchThroMyself: null,
            existingCCPPlan: null,
            doesNotQualifProd: null,
            policyAppInProcess: null,
            myinfoTransactionId: "",
            dobMisMatch: true,
          })
        );
      }
      return true;
    }
    return false;
  };
  useEffect(() => {
    const transaction_id: string = urlParams.get("transaction_id") || "";
    const isManualDataParam: string = urlParams.get("manual_data") || "";
    if (isManualDataParam === "available") {
      //@ts-ignore
      if (errorState?.errorMessage) {
        //@ts-ignore
        setApiError(errorState?.errorMessage);
        //@ts-ignore
        setApiErrorTitle(getErrorTitle(errorState?.errorCode));
      }
      if (
        basicInfo?.forwhom === "myself" &&
        !errorState?.errorMessage &&
        dobMismatchfn(values.dateOfBirth, basicInfo?.dob, false)
      ) {
        setDobModal(true);
        return;
      } else if (basicInfo?.forwhom === "child") {
        let flag = true;
        let atleastOneCategoryHasMatchDOB = false;
        const data: any = store.getState().cancerCoverStep4;
        for (const key of OBJ_KEYS) {
          if (data[key] && Array.isArray(data[key])) {
            const found = data[key].find((child: { dateOfBirth: string }) => {
              return !dobMismatchfn(
                basicInfo?.dob || "",
                child?.dateOfBirth,
                true
              );
            });

            if (found) {
              atleastOneCategoryHasMatchDOB = true;
              break;
            }
          }
        }
        const filteredChildList =
          store
            .getState()
            .cancerCoverStep4?.availToPurch?.reduce((acc: any, child: any) => {
              const isDisabled = dobMismatchfn(
                child.dateOfBirth,
                basicInfo?.dob,
                true
              );
              const childNew = { ...child, isDisabled };
              acc.push(childNew);
              if (!isDisabled && flag) {
                flag = false;
              }
              return acc;
            }, []) || [];

        dispatch(
          updateMyChildRecord({
            ...store.getState().cancerCoverStep4,
            availToPurch: filteredChildList,
          })
        );

        if (
          !errorState?.errorMessage &&
          flag &&
          !atleastOneCategoryHasMatchDOB
        ) {
          setDobModal(true);
          return;
        } else if (!errorState?.errorMessage) {
          dispatch(updatePartialDataStep4({ dobMisMatch: false }));
        }
      }
      nameChunksProcesses({ ...values });
      return;
    }

    if (transaction_id === "" && !myinfotransactionId) {
      history.push(ROUTE_PATH.CANCER_COVER_SINGPASS);
      return;
    }
    if (
      myinfotransactionId === transaction_id &&
      isSingpassInitiated === "SINGPASS"
    ) {
      trackOnLoad();

      return;
    }

    handleConsent(transaction_id);
  }, []);

  // useEffect(() => {
  //   if (verifyInfo === undefined && personalInfo?.customerId) {
  //     if (verifyAge() === false) return;
  //     if (verifyResidental() === false) return;
  //     if (verifyIncomplete() === false) return;
  //     setVerifyInfo("");
  //   }
  // }, [personalInfo, verifyAge, verifyIncomplete, verifyInfo, verifyResidental]);

  return (
    <>
      <ContainerWithStepper
        currentStep={ROUTE_PATH.CANCER_COVER_MY_INFO}
        backButtonPath={ROUTE_PATH.CANCER_COVER_QUOTATION_SUMMARY}
      >
        <div>
          <ContentContainer>
            <Typography variant="title" align="center">
              Check your details
            </Typography>
            <Typography
              variant="description"
              align="center"
              color={themeDefault.colors.grey[1200]}
            >
              Your details were filled automatically from Myinfo.
            </Typography>
          </ContentContainer>
          {basicInfo?.forwhom === "child" && (
            <div>
              <ChildInfo />
            </div>
          )}
          <SectionContainer>
            <Text
              fSize="18px"
              mg="0 0 24px 0"
              style={{
                borderBottom: `1px solid ${themeDefault.colors.grey[700]}`,
                paddingBottom: "24px",
                width: "100%",
              }}
            >
              {basicInfo?.forwhom === "child"
                ? "Applicant-Personal Information"
                : "Personal Information"}
            </Text>
            <FormContainer>
              <InputGroup
                labelColor="#434343"
                id="fullName"
                name="fullName"
                label="Full Name"
                placeholder=""
                onChange={(e: any) => {
                  let formatted_name = e.target.value.replace(/[^a-z\s]/gi, "");
                  onInputChange({
                    target: { value: formatted_name, name: e.target.name },
                  });
                }}
                invalid={!isEmpty(errors?.fullname?.message)}
                errorMessage={errors?.fullname?.message}
                inputProps={{
                  textAlign: "left",
                  value: values["fullName"],
                }}
                inputType={"input"}
                readOnly={true}
              />
              <InputGroup
                labelColor="#434343"
                id="salutation"
                name="salutation"
                label="Salutation"
                inputType="dropdown"
                placeholder="Select"
                theme={themeDefault}
                dropdownProps={{
                  value: values["salutation"],
                  source: salutationList,
                }}
                onChange={onInputChange}
                onBlurShowError={true}
                invalid={!isEmpty(errors?.salutation?.message)}
                errorMessage={
                  errors?.salutation?.message && "Select an option."
                }
              />
              <InputGroup
                labelColor="#434343"
                id="lastName"
                name="lastName"
                label="Last/Family Name"
                placeholder=""
                onChange={(e: any) => {
                  let formatted_name = e.target.value.replace(/[^a-z\s]/gi, "");
                  handleChange({
                    target: { value: formatted_name, name: e.target.name },
                  });
                }}
                invalid={!isEmpty(errors?.lastName?.message)}
                errorMessage={errors?.lastName?.message}
                inputProps={{
                  textAlign: "left",
                  value: values["lastName"] || "",
                }}
                inputType={"swapbuttonname"}
                readOnly={true}
                swapButtonOnClick={() => {
                  setSwapName("lastName");
                  // nameChunksProcesses(values);
                }}
              />
              <InputGroup
                labelColor="#434343"
                id="firstName"
                name="firstName"
                label="First/Given Name"
                placeholder=""
                onChange={(e: any) => {
                  let formatted_name = e.target.value.replace(/[^a-z\s]/gi, "");
                  handleChange({
                    target: { value: formatted_name, name: e.target.name },
                  });
                }}
                invalid={!isEmpty(errors?.firstName?.message)}
                errorMessage={errors?.firstName?.message}
                inputProps={{
                  textAlign: "left",
                  value: values["firstName"] || "-",
                }}
                inputType={"swapbuttonname"}
                readOnly={true}
                swapButtonOnClick={() => {
                  setSwapName("firstName");
                  // nameChunksProcesses(values);
                }}
              />
              <div className="nameDisclaimer">
                <span>
                  <img src={warningIcon} alt="warning icon" />
                  <p>
                    Please <b>ensure your name sequence is correct</b> before
                    proceeding to avoid payment issues and maintain accuracy of
                    your records.
                  </p>
                </span>
              </div>
              <InputGroup
                inputPropsForInputBox={{
                  inputMode: "tel",
                  inputType: "tel",
                }}
                labelColor="#434343"
                id="mobileNum"
                name="mobileNum"
                label="Mobile Number"
                theme={themeDefault}
                placeholder=""
                onChange={(e: any) => {
                  const regex = /^\d+$/;
                  const value = e.target.value;
                  if ((regex.test(value) && value.length < 9) || !value)
                    onInputChange(e);
                }}
                invalid={!isEmpty(errors?.mobileNum?.message)}
                errorMessage={errors?.mobileNum?.message}
                inputProps={{
                  textAlign: "left",
                  value: values["mobileNum"] || "",
                }}
                inputType={"input"}
                mobCode="+65"
                onBlurShowError={false}
              />
              <InputGroup
                inputPropsForInputBox={{
                  inputMode: "email",
                  inputType: "email",
                }}
                labelColor="#434343"
                id="emailId"
                name="emailId"
                label="Email"
                placeholder=""
                theme={themeDefault}
                onChange={(e: any) => {
                  const regex = /^\s*.{0,50}\s*$/;
                  const value = e.target.value;
                  if (regex.test(value)) onInputChange(e);
                }}
                invalid={!isEmpty(errors?.emailId?.message)}
                errorMessage={
                  errors?.emailId?.message &&
                  "Enter in the format: example@mail.com."
                }
                inputProps={{
                  textAlign: "left",
                  value: values["emailId"] || "",
                }}
                inputType={"input"}
                onBlurShowError={false}
              />
              <InputGroup
                labelColor="#434343"
                id="dateOfBirth"
                name="dateOfBirth"
                label="Date of Birth"
                placeholder=""
                onChange={onInputChange}
                invalid={!isEmpty(errors?.dateOfBirth?.message)}
                errorMessage={errors?.dateOfBirth?.message}
                inputProps={{
                  textAlign: "left",
                  value: formatDate(values["dateOfBirth"]) || "",
                }}
                onBlurShowError={true}
                inputType={"input"}
                readOnly={true}
              />
              <InputGroup
                labelColor="#434343"
                id="nric"
                name="nric"
                label="NRIC"
                placeholder=""
                onChange={onInputChange}
                invalid={!isEmpty(errors?.nric?.message)}
                errorMessage={errors?.nric?.message}
                inputProps={{
                  textAlign: "left",
                  value: values["nric"] || "",
                }}
                onBlurShowError={true}
                inputType={"input"}
                readOnly={true}
              />
              <InputGroup
                labelColor="#434343"
                id="nationality"
                name="nationality"
                label="Nationality"
                placeholder=""
                invalid={!isEmpty(errors?.nationality?.message)}
                errorMessage={errors?.nationality?.message}
                inputProps={{
                  textAlign: "left",
                  value:
                    values["nationality"] === "SINGAPORE CITIZEN"
                      ? "Singaporean"
                      : values["nationality"] || "",
                }}
                onBlurShowError={true}
                inputType={"input"}
                readOnly={true}
              />
              <InputGroup
                labelColor="#434343"
                id="residentialStatus"
                name="residentialStatus"
                label="Residential Status"
                placeholder=""
                invalid={!isEmpty(errors?.residentialStatus?.message)}
                errorMessage={errors?.residentialStatus?.message}
                inputProps={{
                  textAlign: "left",
                  value: values["residentialStatus"] || "",
                }}
                onBlurShowError={true}
                inputType={"input"}
                readOnly={true}
              />
              <InputGroup
                labelColor="#434343"
                id="gender"
                name="gender"
                label="Gender"
                placeholder=""
                invalid={!isEmpty(errors?.gender?.message)}
                errorMessage={errors?.gender?.message}
                inputProps={{
                  textAlign: "left",
                  value: values["gender"] || "",
                }}
                onBlurShowError={true}
                inputType={"input"}
                readOnly={true}
              />
            </FormContainer>
          </SectionContainer>
          <SectionContainer>
            <Text fSize="16px">Let's stay in touch - on your terms</Text>
            <Text
              mbFsize="14px"
              color={themeDefault.colors.grey[1200]}
              weight={400}
              mg={"8px 0 24px 0"}
            >
              Experience better ways to financial freedom with our exclusive
              offers and news via email, mail, calls and messaging platforms.
              Simply tell us if you're interested and update your preference
              anytime!
            </Text>
            <div className={marketingRadioStyle}>
              <Checkbox
                type="radio"
                theme={themeDefault}
                checked={
                  personalInfo["stayInTouch"] === "SMS,Y|Phone,Y|Mail,Y|EMail,Y"
                }
                name="stayInTouch"
                newRedio={true}
                margin="0 0 24px 0"
                onChange={() => {
                  dispatch(
                    updateMyInfoRecord({
                      ...personalInfo,
                      stayInTouch: "SMS,Y|Phone,Y|Mail,Y|EMail,Y",
                    })
                  );
                }}
              >
                <TextNormal>
                  Yes please, I want to hear about offers and news just for me
                </TextNormal>
              </Checkbox>
            </div>
            <div className={marketingRadioStyle}>
              <Checkbox
                type="radio"
                theme={themeDefault}
                checked={
                  personalInfo["stayInTouch"] === "SMS,N|Phone,N|Mail,N|EMail,N"
                }
                name="stayInTouch"
                newRedio={true}
                onChange={() => {
                  dispatch(
                    updateMyInfoRecord({
                      ...personalInfo,
                      stayInTouch: "SMS,N|Phone,N|Mail,N|EMail,N",
                    })
                  );
                }}
              >
                <TextNormal>
                  No thanks, I don't want to hear about offers and news just for
                  me
                </TextNormal>
              </Checkbox>
            </div>
            <Text
              mbFsize="12px"
              weight={500}
              color={themeDefault.colors.grey[500]}
              mg="24px 0 0"
            >
              Update your preference anytime, anywhere at{" "}
              <Link
                text="MySinglife"
                variant="link"
                target="_blank"
                rel="noopener noreferrer"
                url="https://www.singlife.com/mysinglife"
                color={themeDefault.colors.primary}
                fontSize={12}
                fontSizeTablet={12}
                underline
              />{" "}
              or contact Singlife at{" "}
              <Link
                text=" +65 6827 9933. "
                variant="link"
                url="tel:+6568279933"
                color={themeDefault.colors.primary}
                fontSize={12}
                fontSizeTablet={12}
                underline
                className={LinkCss}
              />
            </Text>
          </SectionContainer>
          <Wrap>
            <Text
              mbFsize="14px"
              fSize="12px"
              mg="36px 24px 64px 24px"
              weight={500}
            >
              The details you provided for mobile number and email will be
              updated in MySinglife records for all your general insurance, life
              and health policies except for MINDEF/MHA/POGIS after application
              is successful.
            </Text>
            <Center>
              <Button
                label="Confirm"
                variant="default"
                width="180px"
                height="52px"
                padding="15px 0"
                margin="-30px 0 24px"
                theme={themeDefault}
                disabled={
                  !personalInfo["stayInTouch"] ||
                  !values["salutation"] ||
                  !values["emailId"] ||
                  !values["mobileNum"] ||
                  !errors?.emailId?.isValid ||
                  !errors?.mobileNum?.isValid ||
                  (apiError !== "" &&
                    apiError !== undefined &&
                    apiError !== null) ||
                  (basicInfo?.forwhom === "child" && !selectedChild)
                }
                onClick={() => {
                  myInfoValidation();
                  trackOnCTA({
                    ctaText: "Confirm",
                    ctaType: "qb:link",
                  });
                }}
              />
            </Center>
          </Wrap>
        </div>
      </ContainerWithStepper>
      <ModalNameSelector
        show={swapName !== "" ? true : false}
        headerTitle={
          swapName === "firstName"
            ? "first name/given name"
            : "last name/family name"
        }
        selectorItems={
          swapName === "firstName"
            ? firstNameListingChucks || []
            : lastNameListingChucks || []
        }
        onCancelClick={() => {
          setSwapName("");
        }}
        onSaveClick={(value) => {
          swapName === "firstName" && firstNameOnChange(value.nameItems);
          swapName === "lastName" && lastNameOnchange(value.nameItems);
          setSwapName("");
        }}
      />
      {apiError || verifyInfo ? (
        <ErrorModal
          error={getErrorInfor().description}
          title={getErrorInfor().title}
        />
      ) : null}
      {dobModal ? (
        <DateOfBirthModal
          onCloseFn={() => {
            setDobModal(false);
          }}
          onBackToQuote={() => {
            if (basicInfo?.forwhom === "child") {
              dispatch(
                updatePartialDataStep4({
                  singpassInitiatedOrManual: null,
                  selectedChildInfo: null,
                  error: null,
                  availToPurch: null,
                  purchThroMyself: null,
                  existingCCPPlan: null,
                  doesNotQualifProd: null,
                  policyAppInProcess: null,
                  myinfoTransactionId: "",
                  dobMisMatch: true,
                })
              );
            }
            history.push(ROUTE_PATH.CANCER_COVER_BASIC_INFO);
          }}
        />
      ) : null}
    </>
  );
}

export default Myinfo;

// const ContentContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   row-gap: 16px;
//   margin: 0 0 24px 0;
//   @media screen and (min-width: 768px) {
//     margin: 0;
//     padding: 0;
//   }
// `;
const marketingRadioStyle = css`
  padding: 16px 24px;
`;

const Center = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  width: 100%;
  gap: 8px;
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    flex-direction: row;
  }
`;

const FormContainer = styled.div`
  display: flex;
  flex-flow: wrap;
  column-gap: 24px;
  row-gap: 36px;
  width: 100%;
  font-family: inherit;
  div[data-comp="dd"] {
    p {
      font-size: 14px;
    }
  }
  & > div {
    width: 48%;
  }
  @media screen and (max-width: 719px) {
    div {
      width: 100%;
    }
  }
  @media screen and (max-width: 588px) {
    font-size: 14px;
    div {
      width: 100%;
    }
  }
  .nameDisclaimer {
    width: 100%;
    border-radius: 16px;
    padding: 16px;
    background-color: #fffce4;
    color: #434343;
    margin-top: -16px;
    span {
      display: flex;
      gap: 8px;
      align-items: flex-start;
      p {
        font-size: 14px;
        line-height: 19.6px;
        b {
          font-weight: 600;
        }
      }
    }
  }
`;

const SectionContainer = styled.div<{ margin?: string }>`
  background-color: #FFFFFF
  border-radius: 24px;
  opacity: 1;
  /* -webkit-transition: opacity 0.5s ease-in;
    -moz-transition: opacity 0.5s ease-in;
    -o-transition: opacity 0.5s ease-in;
    -ms-transition: opacity 0.5s ease-in;
    transition: opacity 0.5s ease-in; */
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  // gap: 64px;
  transition: all 0.2s ease;
  max-width: 792px;
  margin: 36px auto auto;
  padding: 24px 16px;

  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    padding: 24px 24px;
  }
`;

const LinkCss = css`
  u {
    white-space: nowrap;
  }
`;
const TextNormal = styled.div`
  color: #434343;
  margin: 0;
  letter-spacing: 0.04em;

  @media screen and (max-width: 588px) {
    line-spacing: 19.6px;
  }
`;

interface TextProps {
  color?: string;
  fSize?: string;
  weight?: number;
  mg?: string;
  mbFsize?: string;
}
const Text = styled.div<TextProps>`
  color: ${(props) =>
    props.color ? props.color : themeDefault.colors.grey[500]};
  font-weight: ${(props) => (props.weight ? props.weight : 600)};
  font-size: ${(props) => (props.fSize ? props.fSize : "12px")};
  margin: ${(props) => (props.mg ? props.mg : "0")};
  @media screen and (max-width: 588px) {
    font-size: ${(props) => props.mbFsize || "16px"};
    line-spacing: 140%;
  }
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 16px;
  margin: 0 0 24px 0;
  p:first-child {
    font-size: 24px;
  }
  p:nth-child(2) {
    font-size: 14px;
    font-weight: 600;
  }
  @media screen and (min-width: 768px) {
    padding: 0;
    p:first-child {
      font-size: 28px;
    }
  }
`;

const Wrap = styled.div`
  max-width: 792px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 0 16px;
  flex-direction: column;
  flex-wrap: wrap;
  div:first-child {
    max-width: 327px;
    margin: auto 0px;
    font-size: 12px;
    font-weight: 500;
    padding: 24px 0px;
    margin-bottom: 40px;
  }
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    padding: 0 24px;
    div:first-child {
      max-width: 100%;
      margin: auto 0px;
      letter-spacing: 0.18px;
      font-size: 12px;
      font-weight: 500;
      padding: 24px 0px;
      margin-bottom: 40px;
    }
  }
`;
